<script lang="ts" setup>
const props = defineProps({
  section: {
    type: Object as PropType<Section>,
    required: true,
  },
  paragraphPositionData: {
    type: Array as PropType<ParagraphPositionData[]>,
    default: [],
  },
  isSubSection: {
    type: Boolean,
    default: false,
  },
});

const sectionColspan = computed(() => {
  const baseColSpan = props.isSubSection ? 1 : 2;

  if (props.section.displayParagraphColumns) {
    return baseColSpan;
  }

  return baseColSpan + 1;
});

const positionData = computed(() => {
  return props.section.paragraphPositionsData ?? props.paragraphPositionData;
});
</script>

<template>
  <tr class="bg-light-default border-b last:border-none">
    <td
      v-if="isSubSection == true"
      class="border-r border-collapse collapse"
    ></td>
    <td
      :colspan="sectionColspan"
      class="py-1 px-2 font-bold"
      :class="{
        'border-r': section.displayParagraphColumns,
      }"
    >
      {{ section.title }}
    </td>
    <td v-if="section.displayParagraphColumns" class="text-center">
      <table class="w-full">
        <tr>
          <td
            v-for="paragraphData in positionData"
            class="border-r last:border-none text-center font-bold"
          >
            {{ paragraphData.shortLabel }}
          </td>
        </tr>
      </table>
    </td>
  </tr>
  <DocumentChecklistCriteria
    v-for="(criteria, index) in section.criteriaInstances"
    :key="index"
    :criteria="criteria"
    :paragraph-position-data="positionData"
  />
  <DocumentChecklistSection
    v-for="subSection in section.sections ?? []"
    :key="subSection.id"
    :section="subSection"
    :isSubSection="true"
    :paragraph-position-data="positionData"
  />
</template>

<style scoped></style>
